export const extractMlKeywordData = (metadata) => {
  return metadata
    ?.map((section) => {
      const sectionId = section.id;
      const sectionName = section.name;

      return section.questions
        .map((question) => {
          const questionId = question.id;
          const questionName = question.text;

          return question.observations.map((observation) => {
            const observationId = observation.id;
            const observationName = observation.text || "Observation 1";

            return {
              sectionId,
              sectionName,
              questionId,
              questionName,
              observationId,
              observationName,
            };
          });
        })
        .flat();
    })
    .flat();
};

export const groupMlKeywordData = (metadata) => {
  return extractMlKeywordData(metadata).reduce((audits, item) => {
    const {
      auditId,
      auditName,
      sectionId,
      sectionName,
      questionId,
      questionName,
      observationId,
      observationName,
    } = item;

    let audit = audits.find((a) => a.auditId === auditId);
    if (!audit) {
      audit = {
        auditId,
        auditName,
        sections: [],
      };
      audits.push(audit);
    }

    let section = audit.sections.find((s) => s.sectionId === sectionId);
    if (!section) {
      section = {
        sectionId,
        sectionName,
        questions: [],
      };
      audit.sections.push(section);
    }

    let question = section.questions.find((q) => q.questionId === questionId);
    if (!question) {
      question = { questionId, questionName, observations: [] };
      section.questions.push(question);
    }

    question.observations.push({ observationId, observationName });

    return audits;
  }, []);
};

export const getTextResponses = (responses) =>
  Array.isArray(responses)
    ? responses.filter(
        (res) =>
          res?.flexibleQuestion?.questionType === "Text Field" &&
          res?.notes?.trim(),
      )
    : [];
